import React, { Component } from 'react';
import autobind from 'react-autobind';
import { Row, Col } from 'antd';
import translate from 'app/translations';
import ConfirmApproveSteps from './ConfirmApproveSteps';

export default class ConfirmApprove extends Component {
  constructor(props) {
    super(props);
    autobind(this);
    this.t = translate;
  }

  render() {
    return (
      <div>
        <Row gutter={16}>
          <Col lg={24} xl={24}>
            <p className="emphasized-text">{this.t('ConfirmApprove.info')}</p>
            <p>
              {this.t('ConfirmApprove.nextSteps')}
              <ConfirmApproveSteps />.
            </p>
          </Col>
        </Row>
      </div>
    );
  }
}
